<template>
  <div id="registration">
    <call />
    <pop-alert />
    <top-bar title="お客様情報" backUrl="/account/profile" v-if="this.fromPage == '/account/profile'"/>
    <main>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
        <!-- identification -->
        <section>
            <div class="l-auth">
                <div class="l-auth__box">
                   <div class="font-bold text-center mb-12" style="font-size: 24px;" v-if="this.fromPage != '/account/profile'">
                    お客さま情報
                   </div>
                    <div class="l-auth__title text-center font-size-18 mb-32">
                      {{ this.fromPage != '/account/profile' ? 'お客様の基本情報を入力してください' : 'お客さまの基本情報を入力してください'}}
                    </div>
                    <div class="l-auth__box l-auth__box--sm mt-32">
                        <div class="l-auth__title l-auth__title--sm">性別</div>
                        <div class="c-select-gender">
                            <input type="radio" name="gender" id="gender_famale" v-model="gender" value="1"><label for="gender_famale">女性</label>
                            <input type="radio" name="gender" id="gender_male" v-model="gender" value="2"><label for="gender_male" value="2">男性</label>
                            <input type="radio" name="gender" id="gender_unanswered" v-model="gender" value="0"><label for="gender_unanswered" value="0">回答しない</label>
                        </div>
                    </div>
                    <div class="l-auth__box l-auth__box--sm">
                        <div class="l-auth__title l-auth__title--sm">生年月</div>
                        <div class="c-select-date">
                            <select name="" id="" v-model="birthdayYear">
                                <option v-for="num in yearSelectMaxNum" :selected="num == birthdayYear" :value="String(1919+num)" :key="num">{{1919+num}}年</option>
                            </select>
                            <select name="" id="" v-model="birthdayMonth">
                                <option value="1">1月</option>
                                <option value="2">2月</option>
                                <option value="3">3月</option>
                                <option value="4">4月</option>
                                <option value="5">5月</option>
                                <option value="6">6月</option>
                                <option value="7">7月</option>
                                <option value="8">8月</option>
                                <option value="9">9月</option>
                                <option value="10">10月</option>
                                <option value="11">11月</option>
                                <option value="12">12月</option>
                            </select>
                        </div>
                    </div>
                    <div class="l-auth__box l-auth__box--xl pb-50 line-bottom">
                        <div class="l-auth__title l-auth__title--sm d-flex">郵便番号（7桁） <div class="font-size-11">ハイフンを入れずに入力してください</div></div>
                        <div class="c-btn--center c-btn__white c-btn__white--multi c-input-zip-wrap">
                            <input type="tel" class="c-otp c-input-zip" v-model="zipcode" maxlength="7">
                        </div>
                    </div>
                    <div class="l-auth__box l-auth__box--xl" style="display: none;">
                        <div class="l-auth__title l-auth__title--sm">プッシュ通知設定</div>
                        <div class="c-btn c-btn--center c-btn__white c-btn__white--multi">
                            <span>プッシュ通知設定</span>
                            <small>重要なお知らせを受け取れます</small>
                            <div class="c-btn__white--noti">未設定</div>
                        </div>
                    </div>
                    
                    <div v-on:click.stop.prevent="registration()" class="btn-tutorial mt-32 mx-auto mb-30">登録を完了する</div>
                    <div v-if="this.fromPage != '/account/profile'" v-on:click.stop.prevent="skip()" class="l-auth__external-link mb-24 font-bold"><a href="">スキップする</a></div>
                </div>
            </div>
            <alert :message="alert_msg" 
              :show="alert_show" 
              :closeModal="closeModal" 
              :confirm_show="confirm_show" 
              :confirm_message="confirm_msg" 
              :confirm_callback="confirm_callback" 
              :confirm_hide_cancel="confirm_hide_cancel"
              :label_cancel="confirm_label_cancel"
              :label_ok="confirm_label_ok"
            ></alert>
          </section>
      </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { DB, USER_COLLECTION_KEY } from "../config/const.js";
import firebaseApp from "../common/firebaseProject";
import firebase from "@firebase/app";
import PopAlert from "../components/PopAlert.vue";
import { 
  getUser,
  updateUserFirstStartupTime,
  updateUserLastStartupTime
} from "../store/firestore.js";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "Registration",
  components: {
    'alert': Alert,
    PopAlert,
    TopBar
  },
  mixins: [Tenant],
  data() {
    return {
      shopName: '',
      newsList: [],
      totalProviders: 0,
      loader: false,
      newsSize: 4,
      newsAll: [],
      scrollHeight: 0,
      yearSelectMaxNum: 0,

      gender: 0,
      birthdayYear: 1980,
      birthdayMonth: 1,
      birthmonth: '198001',
      zipcode: '',

      fromPage: '',
      loading: false
    }
  },
  created() {
    this.init();

    // どこからの画面遷移か確認
    this.fromPage = Common.getUrlParam('from-page');

    let y = this.getSelectYear(new Date());
    this.yearSelectMaxNum = y - 1920 + 1;

    this.checkUser();
  },
  mounted() {
    Common.initDom();
  },
  watch: {
    zipcode: function (val) {
      this.zipcode = val.substr(0, 7)
    },
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
    },
    async checkUser() {
      // ユーザーがいるか確認
      if (!this.$store.state.userId && this.$store.state.userId.length == 0) {
        return;
      }
      var docRef = DB.collection('user').doc(this.$store.state.userId);
      var user = await docRef.get();
      var userData = user.data();
      
      this.gender = userData?.gender;
      this.birthdayYear = userData?.birthdayYear;
      this.birthdayMonth = userData?.birthdayMonth;
      this.birthmonth = this.birthdayYear + (this.birthdayMonth < 10 ? "0" : "") + this.birthdayMonth;
      this.zipcode = userData?.zipcode;
    },
    registration() {
      this.loadingShow();
      this.loginAnonymous();
    },
    async skip() {
      this.loadingShow();
      this.loginAnonymous(true);
    },
    async loginAnonymous(isSkip) {
      let data = {};
      if (isSkip == true) {
        data = {
          gender: '',
          birthdayYear: '',
          birthdayMonth: '',
          birthmonth: '',
          zipcode: '',
        }
      } else {
        data = {
          gender: this.gender,
          birthdayYear: String(this.birthdayYear),
          birthdayMonth: this.birthdayMonth,
          birthmonth: this.birthmonth,
          zipcode: this.zipcode
        }
      }
      let loginType = this.$store.state.loginType;
      let uid = firebase.auth().currentUser?.uid;
      if (this.userId && this.userId == uid) {
        await DB.collection(USER_COLLECTION_KEY).doc(this.userId).update(data);
        const user = await getUser(this.userId);
        if (!user.firstStartupTime) {
          await updateUserFirstStartupTime(this.$store.state.userId);
        }
        await updateUserLastStartupTime(this.$store.state.userId);
        this.loadingHide();
        if (isSkip) {
          this.$router.push('/top');
        } else {
          this.$router.push('/account/profile');
        }
      } else {
        firebaseApp.auth().signInAnonymously()
        .then(async () => {
          const uid = firebaseApp.auth().currentUser.uid;
          await DB.collection(USER_COLLECTION_KEY).doc(uid).set(data);
          const user = await getUser(uid);
          if (!user.firstStartupTime) {
            await updateUserFirstStartupTime(this.$store.state.userId);
          }
          await updateUserLastStartupTime(this.$store.state.userId);

          this.$store.dispatch('checkLogin', uid)
          this.$store.dispatch('setLoginType', '');

          let fromPage = Common.getUrlParam('from-page');
          if (fromPage) {
            this.$router.push(fromPage);
          } else {
            this.$router.push('/top');
          }
          const idToken = await this.getIdToken();
          if (!idToken) return;
          const callable = firebaseApp.functions('asia-northeast1').httpsCallable('exchangeToken');
          const result = await callable({ idToken: idToken, authType: "anon" })
          .catch(e => {
            throw e;
          })
          if (result.data.status == 'SUCCEED'){
            Common.messageHandlers('login_anonymous', { customToken: result.data.firebaseToken });
          }
          Common.loadingHide();
        })
        .catch(err => {
          Common.loadingHide();
        })
      }
    },
  }
});
</script>
